import React from 'react';
import './style.scss';

export default class FieldEstimate extends React.Component {
  constructor(props) {
    super(props);
    this.hours = React.createRef();
    this.minutes = React.createRef();
  }
  handleChange = ({ target }) => {
    const hours = this.hours.current.value;
    const minutes = this.minutes.current.value;
    this.props.onChange({
      target: {
        name: this.props.name,
        value: this.hoursAndMinutesToSeconds(hours, minutes)
      }
    });
  };

  secondsToHours = (seconds) => {
    return Math.floor(Number(seconds) / 3600);
  };

  secondsToMinutes = (seconds) => {
    return Math.floor((Number(seconds) % 3600) / 60);
  };

  hoursToSeconds = (hours) => {
    return Math.floor(Number(hours) * 3600);
  };

  minutesToSeconds = (minutes) => {
    return Math.floor(Number(minutes) * 60);
  };

  hoursAndMinutesToSeconds = (hours, minutes) => {
    return this.hoursToSeconds(hours) + this.minutesToSeconds(minutes);
  };

  secondsToHoursAndMinutes = (seconds) => {
    const hours = this.secondsToHours(seconds);
    const minutes = this.secondsToMinutes(seconds);
    return { hours, minutes };
  };

  render() {
    const { hours, minutes } = this.secondsToHoursAndMinutes(this.props.value);
    const { disabled } = this.props;
    return (
      <div className="field-estimate">
        <div className="field-estimate-wrapper mr-2" style={{ width: 70 }}>
          <input
            ref={this.hours}
            value={hours ? hours : ''}
            onChange={this.handleChange}
            className="form-control"
            disabled={disabled}
          />
          <span className="text-muted field-estimate-label">hrs</span>
        </div>
        <span>:</span>
        <div className="field-estimate-wrapper ml-2">
          <input
            ref={this.minutes}
            value={minutes ? minutes : ''}
            onChange={this.handleChange}
            className="form-control"
            disabled={disabled}
          />
          <span className="text-muted field-estimate-label">mins</span>
        </div>
      </div>
    );
  }
}
